import React, { useState } from 'react';
import Login from '../components/Login';
import { DataGrid } from '@mui/x-data-grid';
import "../css/Tabla.css";
import { Button, TextField } from '@mui/material';
import Switch from '@mui/material/Switch';
import MatchDialog from '../components/MatchDialog';
import MatchesList from '../components/MatchesList';

const data = [
    {
        id: 1,
        nombre: 'Juan Pérez',
        telefono: '123456789',
        correo: 'juan@example.com',
        ubicacion: 'Buenos Aires',
        titular: 'Juan Pérez',
        marca: 'Renault',
        modelo: 'Kangoo',
        anio: 2015,
        version: 'Full',
        km: 120000,
        patente: 'ABC123',
        estado: 'Usado',
    },
    {
        id: 2,
        nombre: 'María González',
        telefono: '987654321',
        correo: 'maria@example.com',
        ubicacion: 'Rosario',
        titular: 'María González',
        marca: 'Ford',
        modelo: 'Etios',
        anio: 2018,
        version: 'XS',
        km: 80000,
        patente: 'XYZ987',
        estado: 'Usado',
    },
    {
        id: 3,
        nombre: 'Carlos Fernández',
        telefono: '234567890',
        correo: 'carlos@example.com',
        ubicacion: 'Córdoba',
        titular: 'Carlos Fernández',
        marca: 'Fiat',
        modelo: '500',
        anio: 2016,
        version: 'Sport',
        km: 60000,
        patente: 'DEF456',
        estado: 'Usado',
    },
    {
        id: 4,
        nombre: 'Lucía Martínez',
        telefono: '345678901',
        correo: 'lucia@example.com',
        ubicacion: 'Mendoza',
        titular: 'Lucía Martínez',
        marca: 'Volkswagen',
        modelo: 'Polo',
        anio: 2020,
        version: 'Comfortline',
        km: 40000,
        patente: 'GHI789',
        estado: 'Usado',
    },
    {
        id: 5,
        nombre: 'Roberto Sánchez',
        telefono: '456789012',
        correo: 'roberto@example.com',
        ubicacion: 'Salta',
        titular: 'Roberto Sánchez',
        marca: 'Renault',
        modelo: 'Onix',
        anio: 2019,
        version: 'Premier',
        km: 50000,
        patente: 'JKL321',
        estado: 'Usado',
    },
    {
        id: 6,
        nombre: 'Ana López',
        telefono: '567890123',
        correo: 'ana@example.com',
        ubicacion: 'Santa Fe',
        titular: 'Ana López',
        marca: 'Ford',
        modelo: 'Fiesta',
        anio: 2017,
        version: 'Titanium',
        km: 95000,
        patente: 'MNO654',
        estado: 'Usado',
    },
    {
        id: 7,
        nombre: 'Diego Ramírez',
        telefono: '678901234',
        correo: 'diego@example.com',
        ubicacion: 'Tucumán',
        titular: 'Diego Ramírez',
        marca: 'Renault',
        modelo: 'Logan',
        anio: 2019,
        version: 'Intense',
        km: 70000,
        patente: 'PQR876',
        estado: 'Usado',
    }
  // Agrega más lotes de datos aquí
];

const columns = [
  { field: 'nombre', headerName: 'Nombre', width: 150 },
  { field: 'telefono', headerName: 'Teléfono', width: 130 },
  { field: 'correo', headerName: 'Correo', width: 200 },
  { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
  { field: 'titular', headerName: 'Titular', width: 150 },
  { field: 'marca', headerName: 'Marca', width: 100 },
  { field: 'modelo', headerName: 'Modelo', width: 120 },
  { field: 'anio', headerName: 'Año', width: 60 },
  { field: 'version', headerName: 'Versión', width: 130 },
  { field: 'km', headerName: 'Kilómetros', width: 100 },
  { field: 'patente', headerName: 'Patente', width: 120 },
  { field: 'estado', headerName: 'Estado', width: 100 },
];

const comprasColumns = [
  { field: 'nombre', headerName: 'Nombre', width: 150 },
  { field: 'telefono', headerName: 'Teléfono', width: 150 },
  { field: 'correo', headerName: 'Correo', width: 200 },
  { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
  { field: 'descripcionAuto', headerName: 'Descripción del Auto', width: 300 },
  { field: 'presupuesto', headerName: 'Presupuesto', width: 150 },
];

const comprasRows = [
    {
        id: 1,
        nombre: 'María Gomez',
        telefono: '87654321',
        correo: 'maria@mail.com',
        ubicacion: 'Rosario',
        descripcionAuto: 'Busco un Toyota Etios 2018 o similar',
        presupuesto: '5000 USD',
    },
    {
        id: 2,
        nombre: 'Juan Pérez',
        telefono: '12345678',
        correo: 'juan@mail.com',
        ubicacion: 'Córdoba',
        descripcionAuto: 'Interesado en un Renault Logan 2017',
        presupuesto: '9000 USD',
    },
    {
        id: 3,
        nombre: 'Ana López',
        telefono: '98765432',
        correo: 'ana@mail.com',
        ubicacion: 'Buenos Aires',
        descripcionAuto: 'Prefiero un Fiat 500 2016',
        presupuesto: '8000 USD',
    },
    {
        id: 4,
        nombre: 'Carlos Ruiz',
        telefono: '45678901',
        correo: 'carlos@mail.com',
        ubicacion: 'Mendoza',
        descripcionAuto: 'Buscando un Ford Fiesta 2019',
        presupuesto: '7000 USD',
    },
    {
        id: 5,
        nombre: 'Lucía Martínez',
        telefono: '65432109',
        correo: 'lucia@mail.com',
        ubicacion: 'Salta',
        descripcionAuto: 'Interesada en un Volkswagen Polo 2021',
        presupuesto: '10000 USD',
    },
    {
        id: 6,
        nombre: 'Diego Fernández',
        telefono: '23456789',
        correo: 'diego@mail.com',
        ubicacion: 'Santa Fe',
        descripcionAuto: 'Busco un Ford Fiesta 2017',
        presupuesto: '6000 USD',
    }    
  // Más datos de compras...
];


const AdminDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [ventasView, setVentasView] = useState(true); // Estado para manejar la vista
  const [matches, setMatches] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState(null);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = (ventasView ? data : comprasRows).filter((row) =>
      Object.values(row).some((field) => field.toString().toLowerCase().includes(term))
    );
    setFilteredData(filtered);
  };

  const handleSwitchChange = () => {
    setVentasView(!ventasView);
    setFilteredData(ventasView ? comprasRows : data);
  };

  const handleSearchMatches = () => {
    const matches = comprasRows.map((comprador) => {
      const coincidencias = data.filter((vendedor) => {
        const vendedorDescripcion = `${vendedor.marca} ${vendedor.modelo} ${vendedor.anio} ${vendedor.version}`.toLowerCase();
        const descripcionComprador = comprador.descripcionAuto.toLowerCase();
  
        return (
          descripcionComprador.includes(vendedor.marca.toLowerCase()) ||
          descripcionComprador.includes(vendedor.modelo.toLowerCase()) ||
          descripcionComprador.includes(vendedor.anio.toString()) ||
          descripcionComprador.includes(vendedor.version.toLowerCase())
        );
      });
  
      return { comprador, coincidencias };
    }).filter((resultado) => resultado.coincidencias.length > 0); // Filtra solo los compradores con coincidencias
  
    setMatches(matches); // Almacena las coincidencias encontradas
    console.log(matches); // Para verificar los resultados en la consola
  };
  


  
  const handleOpenDialog = (buyer) => {
    setSelectedBuyer(buyer);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const highlightMatch = (text, searchTerm) => {
    if (!searchTerm) return text; // Si no hay término de búsqueda, devuelve el texto original.
  
    return searchTerm.toLowerCase().includes(text.toLowerCase());
  };

  const encontrarCoincidencia = () => {
    let i = 0;
    for (const match of matches) {
        if (match.comprador.id === selectedBuyer.id) {
            return i;
        }
        i++;
    }

    return 0;
  };
  

  return (
    <div className="tabla-container">
      <div className="switch-container">
        {/* Switch arriba a la derecha */}
        <Switch
          checked={ventasView}
          onChange={handleSwitchChange}
          color='success'
          inputProps={{ 'aria-label': 'controlled' }}
        />
      </div>
      <h2 className="tabla-title">{ventasView ? 'Lista de Ventas' : 'Lista de Compras'}</h2>
      <TextField
        label="Buscar..."
        variant="outlined"
        value={searchTerm}
        onChange={handleSearch}
        className="buscador"
        style={{ marginBottom: "20px" }}
      />
      <div className="tabla-wrapper">
        <DataGrid
          rows={filteredData}
          columns={ventasView ? columns : comprasColumns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>
      <Button variant="contained" color="success" onClick={handleSearchMatches} style={{ marginTop: "20px" }}>
        Hacer búsqueda
      </Button>

      {matches.length > 0 && (
        <MatchesList matches={matches} onBuyerClick={handleOpenDialog} />
      )}

      {selectedBuyer && <MatchDialog
        open={openDialog}
        onClose={handleCloseDialog}
        buyer={selectedBuyer}
        matches={matches[encontrarCoincidencia()]?matches[encontrarCoincidencia()].coincidencias : null}
        // matches={matches.find(( buyer ) => buyer.comprador.id === selectedBuyer.id).matches}
        highlightMatch={highlightMatch}
      />}
    </div>
  );
};

export default AdminDashboard;